import PropTypes from "prop-types";
import { Radio } from "top-component-library";
import { UNFULFILLABLE_ITEM_OPTIONS } from "../../constants";
import { TwoColumnRow } from "../../styles";

const radioStyle = { display: "block", marginBottom: 8 };

// Section C: how in-stock-but-unorderable items and out-of-stock items appear.
const UnavailableItemsSection = ({ menu, onChange }) => (
  <div>
    <p>
      <i>
        Note: items appear as &quot;not available&quot; to guests if the menu is shown when orders cannot be placed.
      </i>
    </p>
    <TwoColumnRow>
      <div>
        <h4>Unfulfillable item visibility rules</h4>
        <Radio.Group
          value={menu.show_unfulfillable_items}
          onChange={(event) => onChange("show_unfulfillable_items", event.target.value)}
        >
          {UNFULFILLABLE_ITEM_OPTIONS.map((option) => (
            <Radio key={option.value} value={option.value} style={radioStyle}>
              {option.label}
            </Radio>
          ))}
        </Radio.Group>
      </div>
      <div>
        <h4>Out-of-stock item visibility rules</h4>
        <Radio.Group
          value={Boolean(menu.show_out_of_stock_items)}
          onChange={(event) => onChange("show_out_of_stock_items", event.target.value)}
        >
          <Radio value={false} style={radioStyle}>
            Never show out-of-stock items
          </Radio>
          <Radio value style={radioStyle}>
            Show out-of-stock items per the unfulfillable item visibility rules
          </Radio>
        </Radio.Group>
      </div>
    </TwoColumnRow>
  </div>
);

UnavailableItemsSection.propTypes = {
  menu: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default UnavailableItemsSection;
